import type { IconSvgObject } from './types';

const NoMeetingRoomIcon: IconSvgObject = [
  ["path", { d: "M6.99976 3H14.9998C16.1043 3 16.9998 3.89543 16.9998 5V12.5001M20.9998 20.9999H14.4998M16.9998 6H18.9998C20.1043 6 20.9998 6.89543 20.9998 8V16.5001M3.49976 3.67709C3.18857 4.02965 2.99976 4.49278 2.99976 5V21L16.9998 21.0001V17.0001", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2 2L22 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default NoMeetingRoomIcon;
